import { useGetIdentity, useListContext, useTranslate } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { SortButton } from "@/components/admin/sort-button";
import { BulkActionsToolbar } from "@/components/admin/bulk-actions-toolbar";
import { BulkDeleteButton } from "@/components/admin/bulk-delete-button";
import { BulkExportButton } from "@/components/admin/bulk-export-button";
import { SelectAllButton } from "@/components/admin/select-all-button";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { Link } from "react-router";

import { TopToolbar } from "../layout/TopToolbar";
import { CompanyEmpty } from "./CompanyEmpty";
import { CompanyListFilter } from "./CompanyListFilter";
import { CompanyListContent } from "./CompanyListContent";

export const CompanyList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <List
      title={false}
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      actions={<CompanyListActions />}
      pagination={<ListPagination rowsPerPageOptions={[10, 25, 50, 100]} />}
    >
      <CompanyListLayout />
    </List>
  );
};

const CompanyListLayout = () => {
  const { data, isPending, filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;

  if (isPending) return null;
  if (!data?.length && !hasFilters) return <CompanyEmpty />;

  return (
    <div className="w-full flex flex-row gap-8">
      <CompanyListFilter />
      <div className="w-full flex flex-col flex-1 gap-4 min-w-0">
        <Card className="py-0 overflow-hidden shadow-xs border-border/80">
          <CompanyListContent />
        </Card>
      </div>
      <BulkActionsToolbar>
        <CompanyBulkActionButtons />
      </BulkActionsToolbar>
    </div>
  );
};

const CompanyBulkActionButtons = () => (
  <>
    <SelectAllButton />
    <BulkExportButton />
    <BulkDeleteButton />
  </>
);

const CompanyListActions = () => {
  const translate = useTranslate();
  return (
    <TopToolbar>
      <SortButton fields={["name", "created_at", "nb_contacts", "nb_deals"]} />
      <Button
        variant="outline"
        size="sm"
        asChild
        className="gap-2 cursor-pointer h-9"
      >
        <Link to="/import?entity=company">
          <Upload className="w-4 h-4" />
          Importar
        </Link>
      </Button>
      <ExportButton />
      <CreateButton
        label={translate("resources.companies.action.new", {
          _: "Nova Organização",
        })}
      />
    </TopToolbar>
  );
};
